<template>
  <span class="timer-num">{{sec2txt(seconds)}}</span>
</template>

<script>
  import {mapGetters} from 'vuex'
    export default {
        data() {
            return {

            }
        },
        props: ['seconds'],
        computed: mapGetters(['sec2txt'])
    }
</script>
